import { IPropsSVGType } from '#types/svg.types';
import SVG from './SVG.styled';

export default function CrossInCircle({ width = '24', height = '24', color, isClick }: IPropsSVGType) {
  return (
    <SVG
      width={width}
      height={height}
      $color={color}
      $isClick={isClick}
      $hover="main-orange"
      $isHover={true}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 21.9141C9.36328 21.9141 6.88281 20.8789 5.02734 19.0234C3.17187 17.168 2.13672 14.6875 2.13672 12.0508C2.13672 9.41406 3.17187 6.93359 5.02734 5.07812C6.88281 3.22266 9.36328 2.1875 12 2.1875C14.6367 2.1875 17.1172 3.22266 18.9727 5.07812C22.8203 8.92578 22.8203 15.1758 18.9727 19.0234C17.1172 20.8789 14.6367 21.9141 12 21.9141ZM12 3.35938C9.67578 3.35938 7.48828 4.25781 5.84766 5.89844C4.20703 7.53906 3.30859 9.72656 3.30859 12.0508C3.30859 14.375 4.20703 16.5625 5.84766 18.2031C7.48828 19.8438 9.67578 20.7422 12 20.7422C14.3242 20.7422 16.5117 19.8438 18.1523 18.2031C21.5508 14.8047 21.5508 9.29688 18.1523 5.89844C16.5117 4.25781 14.3242 3.35938 12 3.35938Z" />
        <path d="M16.7816 8.04297L7.99805 16.8264L7.22461 16.0529L16.0082 7.26953L16.7816 8.04297Z" />
        <path d="M7.50781 8.32031L8.28906 7.55859L16.7852 16.0547L16.0039 16.8359L7.50781 8.32031Z" />
    </SVG>
  );
}
